function GetVimeoIDbyUrl(url) {
  var id = false;
  $.ajax({
    url: 'https://vimeo.com/api/oembed.json?url='+url,
    async: false,
    success: function(response) {
      if(response.video_id) {
        id = response.video_id;
      }
    }
  });
  return id;
}
$(document).ready(function(){

  var url = $('.video-popup').attr('data-link');;
  const videoId = GetVimeoIDbyUrl(url);
  const iframeMarkup = '<iframe id="video1" src="https://player.vimeo.com/video/' + videoId + '?title=0&byline=0&portrait=0" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>';

  $('#myCodeVideo .video-responsive').html(iframeMarkup);

    $(".readLess").click(function(){
      console.log('11111');
      $(this).closest('.product_description_index').find('.More-descr').removeClass('active');
      $(this).closest('.product_description_index').find('.less-descr').addClass('active');
    });
   $(".readMore").click(function(){
     console.log('222');
      $(this).closest('.product_description_index').find('.less-descr').removeClass('active');
      $(this).closest('.product_description_index').find('.More-descr').addClass('active');
    });


  
});

 $(document).ready(function(){
	$('.video-popup').magnificPopup({
  	type:'inline',
  	midClick: true,
    callbacks: {
      open: function() {
          var currentSrc = $("#video1")[0].src;
          if(currentSrc.indexOf("autoplay=") != -1){
            currentSrc = currentSrc.replace("autoplay=0","autoplay=1");
            $("#video1")[0].src = currentSrc;
          }else{
            var symbol = $("#video1")[0].src.indexOf("?") > -1 ? "&" : "?";
            $("#video1")[0].src += symbol + "autoplay=1";
          }
      },
      close: function() {
        var currentSrc = $("#video1")[0].src;
        currentSrc = currentSrc.replace("autoplay=1","autoplay=0");
        $("#video1")[0].src = currentSrc;
      }
     }
	});
  });



 
